import { Serializer as JSONAPISerializer } from 'jsonapi-serializer';

export const FormSerializer = new JSONAPISerializer('form', {
  keyForAttribute: 'camelCase',
  attributes: ['id', 'data'],
});
